import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useCallback } from 'react';

import { IOneLink } from '../../../types/oneLink';
import notification from '../../../utils/notification';

interface IProps {
  isOpenDeactivateDialog: boolean;
  handleCloseDeactivateDialog: () => void;
  selectedItem: IOneLink | null;
  handleDisableOneLink: (oneLink: IOneLink) => Promise<void>;
}

const DeactivateOneLinkModal = ({
  isOpenDeactivateDialog,
  handleCloseDeactivateDialog,
  selectedItem,
  handleDisableOneLink,
}: IProps) => {
  const theme = useTheme();

  const handleButtonClick = useCallback(() => {
    if (selectedItem) {
      handleDisableOneLink?.(selectedItem);
    }
    handleCloseDeactivateDialog();
    notification.success(void 0, {
      content: 'One Link deactivated.',
    });
  }, [handleCloseDeactivateDialog, handleDisableOneLink, selectedItem]);

  return (
    <Dialog
      open={isOpenDeactivateDialog}
      sx={{ padding: 14, '& .MuiPaper-elevation': { maxWidth: 444 } }}
      onClose={handleCloseDeactivateDialog}
    >
      <DialogTitle color="text.primary">Deactivate this link?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="body2" sx={{ color: theme.sass.ebony }}>
            Once deactivated, the link will no longer be accessible to recipients.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDeactivateDialog} sx={{ fontWeight: theme.typography.fontWeightMedium }}>
          Cancel
        </Button>
        <Button onClick={handleButtonClick} sx={{ fontWeight: theme.typography.fontWeightMedium }}>
          Deactivate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeactivateOneLinkModal;
